module.exports = __webpack_public_path__ + "media/images/new_logo_70-95f85bcb10ecd16264f1e76528a299ba.svg";